import { type HTMLArkProps, ark } from '@ark-ui/react';

import type { Scale4 } from '../../lib/types';
import { cn } from '../../lib/utils';

type SeparatorProps = HTMLArkProps<'hr'> & {
	orientation?: 'horizontal' | 'vertical';
	size?: Scale4;
	decorative?: boolean;
};

function Separator({
	className,
	orientation = 'horizontal',
	size = '1',
	decorative = true,
	...props
}: SeparatorProps) {
	return (
		<ark.hr
			data-slot="separator"
			data-orientation={orientation}
			data-size={size}
			role={decorative ? 'none' : 'separator'}
			aria-orientation={decorative ? undefined : orientation}
			className={cn('pt-separator', className)}
			{...props}
		/>
	);
}

export { Separator, type SeparatorProps };
